import { CreateOrEditLifecyclePage } from "./CreateOrEditLifecyclePage";
interface CreateLifecyclePageProps {
    spaceId: string;
}
export function CreateLifecyclePage({ spaceId }: CreateLifecyclePageProps) {
    return <CreateOrEditLifecyclePage spaceId={spaceId} create={true}/>;
}
